// extracted by mini-css-extract-plugin
export default {"container":"nav_dropdown_footer-module__container--UpHgO"};